import { Component } from '@angular/core';

@Component({
  selector: 'app-final-stats-section',
  imports: [],
  templateUrl: './final-stats-section.component.html',
  styleUrl: './final-stats-section.component.css',
})
export class FinalStatsSectionComponent {

}
